export enum UserPlanSortOrder {
  UPSO_ON_CREATED = 'UPSO_ON_CREATED',
  UPSO_ON_STATUS = 'UPSO_ON_STATUS',
}
